import React from "react";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, roles }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-200 border-t-blue-600" />
      </div>
    );
  }
  if (user === false) {
    window.location.href = "/login";
    return null;
  }
  if (roles && !roles.includes(user.role)) {
    const dest = user.role === "admin" ? "/centrale" : user.role === "tecnico" ? "/tecnico" : "/";
    window.location.href = dest;
    return null;
  }
  return children;
};
